<template>
  <el-dialog
    :destroy-on-close="true"
    title="编辑客户备注"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="550px"
    class="edit-customer-remark-dialog"
  >
    <el-form :model="form" ref="formRef" label-width="100px">
      <el-form-item label="项目ID">
        <el-input v-model="form.projectId" disabled></el-input>
      </el-form-item>
      <el-form-item label="客户名称" v-if="form.customerName">
        <el-tag type="info" size="medium">{{ form.customerName }}</el-tag>
      </el-form-item>
      <el-form-item label="客户备注" prop="customerRemark">
        <el-input
          v-model="form.customerRemark"
          type="textarea"
          :rows="5"
          placeholder="请输入客户备注内容，如客户需求、沟通记录等"
          maxlength="500"
          show-word-limit
          :autosize="{ minRows: 4, maxRows: 8 }"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="tips-container">
      <i class="el-icon-user"></i>
      <span>客户备注将对客户可见，请注意内容的专业性和准确性</span>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">
        保 存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { requestProjectEditCustomerRemark } from "../api/project";

export default {
  name: "EditCustomerRemarkDialog",
  props: {
    // 是否显示弹窗
    showDialog: {
      type: Boolean,
      default: false
    },
    // 选中的项目详情
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      form: {
        projectId: "",
        customerName: "",
        customerRemark: ""
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("update:showDialog", val);
      }
    }
  },
  watch: {
    selectDetail: {
      handler(newVal) {
        if (newVal) {
          this.form.projectId = newVal.projectId || newVal.id || "";
          this.form.customerName = newVal.customerName || "";
          this.form.customerRemark = newVal.customerRemark || "";
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.form.customerRemark = "";
      this.$emit("update:showDialog", false);
      this.$emit("close");
    },
    // 提交表单
    async handleSubmit() {
      try {
        this.loading = true;

        const submitData = {
          customerRemark: this.form.customerRemark
        };

        const res = await requestProjectEditCustomerRemark(this.form.projectId, submitData);
        if (res?.code === 200) {
          this.$message.success("客户备注保存成功");
          this.$emit("submit", {
            projectId: this.form.projectId,
            ...submitData
          });
          this.handleClose();
        } else {
          this.$message.error(res?.message || "保存失败");
        }
      } catch (error) {
        console.error("编辑客户备注失败:", error);
        this.$message.error("操作失败，请重试");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.edit-customer-remark-dialog /deep/ .el-dialog__body {
  padding: 20px 30px;
}

.edit-customer-remark-dialog /deep/ .el-textarea__inner {
  font-size: 14px;
  line-height: 1.6;
}

.edit-customer-remark-dialog /deep/ .el-tag {
  font-size: 14px;
}

.tips-container {
  background-color: #fdf6ec;
  border-radius: 4px;
  padding: 10px 15px;
  margin-top: 10px;
  color: #e6a23c;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.tips-container i {
  margin-right: 8px;
  color: #e6a23c;
}

.dialog-footer {
  text-align: right;
}
</style>
